// IMPORTANT: 必须在所有 import 'marked' / 'react-markdown' 之前加载！
// 见 src/utils/polyfillAt.js 中的说明。
import './utils/polyfillAt';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import reportWebVitals from './reportWebVitals';
import { initVConsole } from "./utils/vconsole";
import App from './App';
import './index.css';
import axios from 'axios';
import {BrowserRouter} from "react-router-dom";

// H5 mobile real-device debug console.
// Production: comment this line, or set ENABLE_H5_MOBILE_CONSOLE=false in utils/vconsole.js.
initVConsole();

// 1. 请求拦截器：打印入参
axios.interceptors.request.use(config => {
  console.group(`>>> [接口请求] ${config.url}`);
  console.log('请求方式:', config.method.toUpperCase());
  console.log('入参(Data/Params):', config.data || config.params);
  console.groupEnd();
  return config;
}, error => {
  return Promise.reject(error);
});

// 2. 响应拦截器：打印出参
axios.interceptors.response.use(response => {
  console.group(`<<< [接口响应] ${response.config.url}`);
  console.log('状态码:', response.status);
  console.log('返回数据:', response.data);
  console.groupEnd();
  return response;
}, error => {
  console.group(`!!! [接口异常] ${error.config?.url}`);
  console.error('错误信息:', error.message);
  if (error.response) {
    console.error('异常返回:', error.response.data);
  }
  console.groupEnd();
  return Promise.reject(error);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename="/ai-medical">
      <ConfigProvider locale={zhCN}>
        {/*<React.StrictMode>*/}
          <App />
        {/*</React.StrictMode>*/}
      </ConfigProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
